import PasswordRules from './PasswordRules';
import { isPasswordValid } from './password';

export default function ResetPasswordForm({
    password,
    confirmPassword,
    onPasswordChange,
    onConfirmPasswordChange,
    onSubmit,
    error,
    onBack
}) {
    const canSubmit = isPasswordValid(password) && password === confirmPassword;

    return (
        <>
            <h1>Choose a new password</h1>
            <p className="auth-subtitle">Enter a new password for your account.</p>

            <form onSubmit={onSubmit} className="auth-form">
                <div>
                    <input type="password" className="input-field" placeholder="New password" value={password} onChange={e => onPasswordChange(e.target.value)} autoFocus required />
                    <PasswordRules password={password} />
                </div>
                <input type="password" className="input-field" placeholder="Confirm password" value={confirmPassword} onChange={e => onConfirmPasswordChange(e.target.value)} required />
                {confirmPassword && password !== confirmPassword && (
                    <div className="auth-error">Passwords do not match.</div>
                )}

                {error && <div className="auth-error"><i className="fa-solid fa-triangle-exclamation"></i>{error}</div>}

                <button type="submit" className="btn-primary auth-submit" disabled={!canSubmit}>Update password</button>
            </form>

            <p className="auth-switch">
                <button type="button" className="auth-link muted" onClick={onBack}>Back to sign in</button>
            </p>
        </>
    );
}
